/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-05-16T17:00:11.452
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getEvaluateAppointmentFinalRejectionEditInit,
	getEvaluateAppointmentFinalRejectionView
} from '@api/storagemanage/EvaluateAppointmentFinalRejection';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getEvaluateAppointmentFinalRejectionEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEvaluateAppointmentFinalRejectionEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getEvaluateAppointmentFinalRejectionView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEvaluateAppointmentFinalRejectionView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
